import React, { FunctionComponent } from 'react'
import { Layout } from 'antd'
import { css } from '@emotion/css'
import RightSider from '../../Map/RightSider/RightSider'
import DevicesList from '../../DevicesList/DevicesList'
import Map from '../../Map/Map'
import { useParams } from '@tanstack/react-router'

const { Content } = Layout

const Agency: FunctionComponent<any> = () => {
  const [mapSettingsCollapsed, setMapSettingsCollapsed] = React.useState(true)

  const agencyId = useParams({ strict: false }).agencyId
  console.log(agencyId)

  return (
    <Layout
      className={css`
        height: 100vh;
      `}
    >
      <Layout>
        <Content style={{ overflow: 'auto', position: 'relative', display: 'flex', flexDirection: 'row' }}>
          <div style={{ flex: 1 }}>
            <DevicesList agencyId={agencyId} />
          </div>
          <div style={{ flex: 2 }}>
            <Map />
          </div>
        </Content>
        <RightSider collapsed={mapSettingsCollapsed} setCollapsed={setMapSettingsCollapsed} />
      </Layout>
    </Layout>
  )
}

export default Agency
